import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * PasswordPreview - устанавливает на контрол с аттрибутом passwordpreview контрол показывающий пароль
 * применяется к элменттом с типом input[type="password"]
 */
export class PasswordPreviewBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('passwordpreview');
    }

    protected installBehaviour(element: HTMLElement): void {
        const previewPasswordConfig: any = Utils.getObjectByAttributes(
            this.tag,
            element,
            null,
            {}
        );

        const id = 'id' + Math.random();
        $(element).attr(this.tagInstalled, id);
        let previewA =
            '<a tabindex="1000" id="' + id + '" onclick="return false;">';
        if (previewPasswordConfig.content) {
            previewA += $(previewPasswordConfig.content).html();
        }
        previewA += '</a>';

        $(element).after(previewA);

        $(element).change((e) =>
            this.handlePasswordInputChanged(e.currentTarget)
        );
        $(element).keyup((e) =>
            this.handlePasswordInputChanged(e.currentTarget)
        );

        const previewButton = $('a[id="' + id + '"]')[0];
        if (previewPasswordConfig.previewbuttonclass) {
            $(previewButton).addClass(previewPasswordConfig.previewbuttonclass);
        }

        $(previewButton).mousedown(this, this.handlePreviewButtonMouseDown);
        $(previewButton).mouseup(this, this.handlePreviewButtonMouseUp);
        $(previewButton).mouseout(this, this.handlePreviewButtonMouseUp);

        $(previewButton).on('touchstart', this, this.handlePasswordTouchStart);
        $(previewButton).on('touchend', this, this.handlePasswordTouchEnd);
        $(previewButton).on(
            'touchcancel',
            this,
            this.handlePasswordTouchCancel
        );

        this.renderPasswordPreview(previewButton);
    }

    private handlePasswordTouchStart(evt: JQueryEventObject) {
        evt.preventDefault();
        evt.data.showPasswordPreview(evt.currentTarget);
    }

    private handlePasswordTouchEnd(evt: JQueryEventObject) {
        evt.preventDefault();
        evt.data.hidePasswordPreview(evt.currentTarget);
    }

    private handlePasswordTouchCancel(evt: JQueryEventObject) {
        evt.preventDefault();
        evt.data.hidePasswordPreview(evt.currentTarget);
    }

    private showPasswordPreview(element: any) {
        const previewButton = $(element);
        const id = previewButton.attr('id');
        const input = $('input[' + this.tagInstalled + '="' + id + '"]');
        input.attr('type', 'text');

        this.renderPasswordPreview(previewButton);
    }

    private hidePasswordPreview(element: any) {
        const previewButton = $(element);
        const id = previewButton.attr('id');
        const input = $('input[' + this.tagInstalled + '="' + id + '"]');
        input.attr('type', 'password');

        this.renderPasswordPreview(previewButton);
    }

    private handlePasswordInputChanged(element: any) {
        const input = $(element);
        const id = input.attr(this.tagInstalled);
        const previewButton = $('a[id="' + id + '"]')[0];

        this.renderPasswordPreview(previewButton);
    }

    private handlePreviewButtonMouseDown(evt: JQueryMouseEventObject) {
        evt.preventDefault();
        evt.data.showPasswordPreview(evt.currentTarget);
    }

    private handlePreviewButtonMouseUp(evt: JQueryMouseEventObject) {
        evt.preventDefault();
        evt.data.hidePasswordPreview(evt.currentTarget);
    }

    private renderPasswordPreview(previewButton) {
        previewButton = $(previewButton);
        const id = previewButton.attr('id');
        const input = $('input[' + this.tagInstalled + '="' + id + '"]');
        const text = input.val();
        if (text && text != '') {
            previewButton.show();
        } else {
            previewButton.hide();
        }

        const inputType = input.attr('type');
        if (inputType == 'password') {
            input.addClass('password-hidden');
            previewButton.addClass('password-hidden');

            input.removeClass('password-visible');
            previewButton.removeClass('password-visible');
        } else {
            input.addClass('password-visible');
            previewButton.addClass('password-visible');

            input.removeClass('password-hidden');
            previewButton.removeClass('password-hidden');
        }
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.PasswordPreviewBehaviour = PasswordPreviewBehaviour;